import { permissionActions } from "./permission";

export const permission_actions = {
  ...permissionActions
};
export { default as permissionSlice } from "./permission";
